// Module
var code = `<template> <div class="page-terms-and-conditions column flex-grow-1 animation-slide-top"> <comp-rich-text-editor class="flex-grow-1 padding-10" html.two-way="item.termsAndConditions" view-model.ref="richTextEditor"></comp-rich-text-editor> </div> </template> `;
// Exports
module.exports = code;